import { getArgumentValue } from '@shared/workflow/getArgumentValue.js';
import { useEffect, useState } from 'react';

const useAsyncArgumentValue = ({ arg, def, responses }) => {
  const [value, setValue] = useState(null);

  useEffect(() => {
    if (!arg && !def) {
      return;
    }

    getArgumentValue({ arg, def, responses }).then(setValue);
  }, [arg, def, responses]);

  return value;
};

export default useAsyncArgumentValue;
